






























































































































































































































import SearchBuilder from "@/builder/SearchBuilder";
import SelectRack from "@/components/custom/select/SelectRack.vue";
import SelectWarehouse from "@/components/custom/select/SelectWarehouse.vue";
import UploadWarehouseTransferAttachment from "@/components/WarehouseTransfer/UploadWarehouseTransferAttachment.vue";
import { debounce } from "@/helpers/debounce";
import useProduct from "@/hooks/useProduct";
import MNotification from "@/mixins/MNotification.vue";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { InventoryLineResponseDto } from "@/models/interface/inventory";
import { ProductDetailDto } from "@/models/interface/master-product";
import { ProductPurchaseResponseDto } from "@/models/interface/ProductPurchaseResponse.interface";
import {
  CreateWarehouseTransferFormState,
  CreateWarehouseTransferFormStateLine,
} from "@/models/interface/warehouse-transfer/CreateWarehouseTransferFormState.interface";
import { logisticServices } from "@/services/logistic.service";
import { productService } from "@/services/product.service";
import { LabelInValue } from "@/types";
import { FormModel } from "ant-design-vue";
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";

@Component({
  components: {
    SelectRack,
    SelectWarehouse,
    UploadWarehouseTransferAttachment,
  },
})
export default class WarehouseTransferMutateForm extends Mixins(MNotification) {
  DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;

  @Prop({ required: false, type: Boolean, default: false })
  pending!: boolean;

  @Prop({ required: false, type: Object, default: undefined })
  defaultState!: CreateWarehouseTransferFormState;

  @Ref("formModel")
  formModel!: FormModel;

  formState: CreateWarehouseTransferFormState =
    new CreateWarehouseTransferFormState();

  formRules = {
    sourceWarehouse: [
      { required: true, message: this.$t("lbl_validation_required_error") },
    ],
    destinationWarehouse: [
      { required: true, message: this.$t("lbl_validation_required_error") },
    ],
  };

  columns = [
    {
      title: this.$t("lbl_rack_from"),
      dataIndex: "rackFrom",
      scopedSlots: { customRender: "rackFrom" },
      width: 200,
    },
    {
      title: this.$t("lbl_part"),
      dataIndex: "part",
      scopedSlots: { customRender: "part" },
    },
    {
      title: this.$t("lbl_serial_number"),
      dataIndex: "serialNumber",
      scopedSlots: { customRender: "serialNumber" },
    },
    {
      title: this.$t("lbl_total_qty"),
      dataIndex: "totalQty",
      scopedSlots: { customRender: "totalQty" },
      width: 100,
    },
    {
      title: this.$t("lbl_uom"),
      dataIndex: "uom",
      scopedSlots: { customRender: "uom" },
      width: 200,
    },
    {
      title: this.$t("lbl_rack_to"),
      dataIndex: "rackTo",
      scopedSlots: { customRender: "rackTo" },
      width: 200,
    },
    {
      title: this.$t("lbl_notes"),
      dataIndex: "notes",
      scopedSlots: { customRender: "notes" },
      width: 200,
    },
  ];

  loading = {
    partOptions: false,
  };

  selectedRowKeys: string[] = [];
  partOptions: Option<InventoryLineResponseDto>[] = [];

  get isNew(): boolean {
    return this.formState.status === "NEW";
  }

  get sourceWarehouseId(): string {
    return this.formState.sourceWarehouse?.key || "";
  }

  get destinationWarehouseId(): string {
    return this.formState.destinationWarehouse?.key || "";
  }

  async getPartOptions(
    params: RequestQueryParamsModel = new RequestQueryParams()
  ): Promise<Option<InventoryLineResponseDto>[]> {
    const parts = await logisticServices.getListInventoryLine(params);
    return parts.data.map(part => ({
      key: part.product.id,
      value: part.product.id,
      label: part.product.name,
      meta: part,
    }));
  }

  setDefaultFormState(state: CreateWarehouseTransferFormState): void {
    this.formState = { ...state };
  }

  setPartOptionsForEachRow(): void {
    const params = new RequestQueryParams();
    if (this.formState.sourceWarehouse?.key) {
      params.search = new SearchBuilder()
        .push([
          "warehouseLocation.warehouse.secureId",
          this.formState.sourceWarehouse.key,
        ])
        .build();
    }
    params.limit = 500;

    this.loading.partOptions = true;
    this.getPartOptions(params)
      .then(options => {
        this.partOptions = options;

        const optionsByLocation = new Map<
          string,
          Option<InventoryLineResponseDto>[]
        >();
        options.forEach(option => {
          const locationId = option.meta?.warehouseLocationId;
          if (!locationId) {
            return;
          }

          const group = optionsByLocation.get(locationId) || [];
          group.push(option);
          optionsByLocation.set(locationId, group);
        });

        this.formState.warehouseTransferLines.forEach(line => {
          if (!line.rackFrom?.key) {
            return;
          }

          line.partOptions = optionsByLocation.get(line.rackFrom.key) || [];
          line.usePartOptions = true;
        });
      })
      .finally(() => {
        this.loading.partOptions = false;
      });
  }

  loadPartOptionsForWarehouse(value?: LabelInValue): void {
    const params = new RequestQueryParams();
    if (value?.key) {
      params.search = new SearchBuilder()
        .push(["warehouseLocation.warehouse.secureId", value.key])
        .build();
    }

    this.loading.partOptions = true;
    this.getPartOptions(params)
      .then(options => {
        this.partOptions = options;
      })
      .finally(() => {
        this.loading.partOptions = false;
      });
  }

  setSerialNumberOptionsForEachRow(): void {
    const { findAllSnForSales } = useProduct();
    const builder = new SearchBuilder();

    const promises: Promise<ProductPurchaseResponseDto[]>[] = [];
    this.defaultState.warehouseTransferLines.forEach(async line => {
      const queries: string[] = [];
      if (line.rackFrom?.key) {
        queries.push(builder.push(["locationId", line.rackFrom.key]).build());
      }
      if (line.part?.key) {
        queries.push(builder.push(["productId", line.part.key]).build());
      }

      const params = new RequestQueryParams();
      params.search = queries.join(SearchBuilder.AND);
      promises.push(findAllSnForSales(params));
    });

    this.formState.warehouseTransferLines.forEach(line => {
      line.loadingSerialNumberOptions = true;
    });
    Promise.all(promises)
      .then(responses => {
        responses.forEach((res, index) => {
          this.formState.warehouseTransferLines[index].serialNumberOptions =
            res.map(sales => ({
              key: sales.serialNumber,
              label: sales.serialNumber,
              value: sales.serialNumber,
            }));
        });
      })
      .finally(() => {
        this.formState.warehouseTransferLines.forEach(line => {
          line.loadingSerialNumberOptions = false;
        });
      });
  }

  setUOMOptionsForEachRow(): void {
    const promises: Promise<ProductDetailDto>[] = [];
    this.defaultState.warehouseTransferLines.forEach(async line => {
      if (line.part?.key) {
        promises.push(productService.getDetailProduct(line.part.key));
      }
    });

    this.formState.warehouseTransferLines.forEach(line => {
      line.loadingUOMOptions = true;
    });
    Promise.all(promises)
      .then(responses => {
        responses.forEach((res, index) => {
          this.formState.warehouseTransferLines[index].uomOptions =
            res.uomConversions.map(uom => ({
              key: uom.uomSourceId,
              label: uom.uomConversion,
              value: uom.uomSourceId,
            }));
        });
      })
      .finally(() => {
        this.formState.warehouseTransferLines.forEach(line => {
          line.loadingUOMOptions = false;
        });
      });
  }

  @Watch("defaultState")
  handleDefaultStateChange(): void {
    if (this.defaultState) {
      this.setDefaultFormState(this.defaultState);
      this.setPartOptionsForEachRow();
      this.setSerialNumberOptionsForEachRow();
      this.setUOMOptionsForEachRow();
    }
  }

  handleSelectedRowKeysChange(keys: string[]): void {
    this.selectedRowKeys = keys;
  }

  handleAddRow(): void {
    this.formState.warehouseTransferLines.push(
      new CreateWarehouseTransferFormStateLine()
    );
  }

  handleDeleteRow(): void {
    this.showConfirmationDeleteItems(() => {
      this.formState.warehouseTransferLines =
        this.formState.warehouseTransferLines.filter(line => {
          const keep = !this.selectedRowKeys.includes(line.rowId);

          if (!keep && !!line.id) {
            this.formState.deletedLineIds.push(line.id);
          }

          return keep;
        });

      this.selectedRowKeys = [];
    });
  }

  handleSourceWarehouseChange(value?: LabelInValue): void {
    const previous = this.formState.sourceWarehouse;
    const hasRackSelected = this.formState.warehouseTransferLines.some(
      line => !!line.rackFrom?.key
    );

    const apply = (): void => {
      this.formState.sourceWarehouse = value;
      this.resetLinesForSourceChange(value);
    };

    if (!hasRackSelected) {
      apply();
      return;
    }

    this.$confirm({
      title: this.$t("lbl_confirmation"),
      content: this.$t("lbl_change_source_warehouse_info"),
      onOk: apply,
      onCancel: () => {
        this.formState.sourceWarehouse = previous;
      },
    });
  }

  handleDestinationWarehouseChange(value?: LabelInValue): void {
    const previous = this.formState.destinationWarehouse;
    const hasRackSelected = this.formState.warehouseTransferLines.some(
      line => !!line.rackTo?.key
    );

    const apply = (): void => {
      this.formState.destinationWarehouse = value;
      this.resetLinesForDestinationChange();
    };

    if (!hasRackSelected) {
      apply();
      return;
    }

    this.$confirm({
      title: this.$t("lbl_confirmation"),
      content: this.$t("lbl_change_destination_warehouse_info"),
      onOk: apply,
      onCancel: () => {
        this.formState.destinationWarehouse = previous;
      },
    });
  }

  resetLinesForSourceChange(value?: LabelInValue): void {
    this.formState.warehouseTransferLines.forEach(line => {
      line.rackFrom = undefined;
      line.part = undefined;
      line.partOptions = [];
      line.usePartOptions = false;
      line.uom = undefined;
      line.uomOptions = [];
      line.serialNumber = undefined;
      line.serialNumberOptions = [];
    });
    this.loadPartOptionsForWarehouse(value);
  }

  resetLinesForDestinationChange(): void {
    this.formState.warehouseTransferLines.forEach(line => {
      line.rackTo = undefined;
    });
  }

  handleRackFromChange(
    row: CreateWarehouseTransferFormStateLine,
    value: LabelInValue | undefined
  ): void {
    row.part = undefined;
    row.uom = undefined;
    row.uomOptions = [];
    row.serialNumber = undefined;
    row.serialNumberOptions = [];

    if (!value?.key) {
      row.partOptions = [];
      row.usePartOptions = false;
      return;
    }

    const params = new RequestQueryParams();
    const builder = new SearchBuilder();
    const queries: string[] = [];

    if (this.sourceWarehouseId) {
      queries.push(
        builder
          .push([
            "warehouseLocation.warehouse.secureId",
            this.sourceWarehouseId,
          ])
          .build()
      );
    }
    queries.push(
      builder.push(["warehouseLocation.secureId", value.key]).build()
    );
    params.search = queries.join(SearchBuilder.AND);

    row.loadingPartOptions = true;
    this.getPartOptions(params)
      .then(options => {
        row.partOptions = options;
        row.usePartOptions = true;
      })
      .finally(() => {
        row.loadingPartOptions = false;
      });
  }

  handlePartSearch(
    row: CreateWarehouseTransferFormStateLine,
    value: string
  ): void {
    debounce(() => {
      const params = new RequestQueryParams();
      const builder = new SearchBuilder();
      const queries: string[] = [];

      if (value) {
        const nameFilter = builder
          .push(["product.name", value], { like: "both" })
          .or()
          .push(["product.code", value], { like: "both" })
          .build();
        queries.push(nameFilter);
      }

      if (row.rackFrom?.key) {
        const warehouseLocationFilter = new SearchBuilder()
          .push(["warehouseLocation.secureId", row.rackFrom.key])
          .build();
        queries.push(warehouseLocationFilter);
      }

      params.search = queries.join(SearchBuilder.AND);
      row.loadingPartOptions = true;
      this.getPartOptions(params)
        .then(options => {
          row.partOptions = options;
          row.usePartOptions = true;
        })
        .finally(() => {
          row.loadingPartOptions = false;
        });
    });
  }

  handlePartChange(
    row: CreateWarehouseTransferFormStateLine,
    value: LabelInValue | undefined
  ): void {
    row.uom = undefined;
    row.uomOptions = [];
    row.serialNumber = undefined;
    row.serialNumberOptions = [];

    if (!value?.key) {
      return;
    }

    row.loadingUOMOptions = true;
    productService
      .getDetailProduct(value.key)
      .then(res => {
        row.uomOptions = res.uomConversions.map(uom => ({
          key: uom.uomSourceId,
          label: uom.uomConversion,
          value: uom.uomSourceId,
        }));

        if (row.uomOptions[0]) {
          row.uom = {
            key: String(row.uomOptions[0].key),
            label: row.uomOptions[0].label,
          };
        }
      })
      .finally(() => {
        row.loadingUOMOptions = false;
      });

    const { findAllSnForSales } = useProduct();
    const params = new RequestQueryParams();
    const builder = new SearchBuilder();
    const queries: string[] = [];

    if (row.rackFrom?.key) {
      queries.push(
        builder.push(["locationId", row.rackFrom.key]).build()
      );
    }
    queries.push(builder.push(["productId", value.key]).build());

    params.search = queries.join(SearchBuilder.AND);

    row.loadingSerialNumberOptions = true;
    findAllSnForSales(params)
      .then(res => {
        row.serialNumberOptions = res.map(sn => ({
          key: sn.serialNumber,
          label: sn.serialNumber,
          value: sn.serialNumber,
        }));
      })
      .finally(() => {
        row.loadingSerialNumberOptions = false;
      });
  }

  handleBack(): void {
    this.$emit("back");
  }

  handleReset(): void {
    this.formState = new CreateWarehouseTransferFormState();
  }

  handleSaveAsDraft(): void {
    this.$emit("saveAsDraft", this.formState);
  }

  handleCreate(): void {
    this.formModel.validate((valid: boolean) => {
      if (!valid) {
        this.showNotifWarning("notif_validation_error");
        return;
      }

      for (const line of this.formState.warehouseTransferLines) {
        if (!line.rackFrom?.key || !line.rackTo?.key) {
          this.showNotifWarning("notif_validation_error");
          return;
        }
        if (line.rackFrom?.key && line.rackFrom.key === line.rackTo?.key) {
          this.showNotifWarning("notif_source_destination_rack_same");
          return;
        }
        if (!line.part || !line.uom) {
          this.showNotifWarning("notif_validation_error");
          return;
        }
        if(Number(line.totalQty) == 0){
          this.showNotifWarning("notif_qty_must_be_greater_than_zero");
          return;
        }
      }

      this.$emit("create", this.formState);
    });
  }
}
